<template>
  <div class="date-range-picker-custom">
    <span v-if="label" class="picker-label">
      {{ label }}
    </span>

    <date-range-picker
      ref="picker"
      v-model="dateRange"
      @update="applyFilter"
      @toggle="handleToggle"
      :opens="options.opens ? options.opens : 'center'"
      :locale-data="{ firstDay: 1, format: 'yyyy-mm-dd' }"
      :ranges="options.ranges ? options.ranges : true"
      :minDate="minDate"
      :maxDate="maxDate"
      :singleDatePicker="false"
      :timePicker="false"
      :timePicker24Hour="false"
      :showWeekNumbers="false"
      :showDropdowns="showDropdown"
      :autoApply="true"
      :linkedCalendars="false"
      :disabled="disabled"
      :class="disabled ? 'disabled': ''">

      <template v-slot:input="picker" style="min-width: 350px;">
        {{ formatDate(picker.startDate) }} - {{ formatDate(picker.endDate) }}
      </template>

    </date-range-picker>
  </div>
</template>

<script>
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'


export default {
  name: 'date-range-picker-custom',

  components: {
    DateRangePicker,
  },

  props: {
    label: {
      type: String,
      default: null,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    startDate: {
      type: String,
      default: () => {
        const currentYear = new Date().getFullYear();
        return `${currentYear}-01-01`;
      }
    },
    endDate: {
      type: String,
      default: () => moment().format('YYYY-MM-DD'),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showDropdown: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      dateRange: {
        startDate: this.startDate,
        endDate: this.endDate,
      },
      minDate: moment('2014-12-31').format('YYYY-MM-DD'),
      maxDate: null,
    };
  },

  methods: {
    handleToggle() {
      // console.log('handleToggle', JSON.stringify(show));
    },

    applyFilter(dateRange) {
      let values = {
        startDate: moment(dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(dateRange.endDate).format('YYYY-MM-DD'),
      };

      this.$emit('update:startDate', values.startDate);
      this.$emit('update:endDate', values.endDate);
      this.$emit('input', values);
    },

    formatDate(dateString) {
      if(dateString) {
        return moment(dateString).format('MMM D, YYYY');
      } else {
        return '--';
      }
    },
  },

  watch: {
    startDate: function (value) {
      if(this.dateRange.startDate !== value) {
        this.dateRange.startDate = value;
      }
    },

    endDate: function (value) {
      if(this.dateRange.endDate !== value) {
        this.dateRange.endDate = value;
      }
    },
  },
}
</script>
